import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { chapters } from "../data/portfolio";

/**
 * Which chapter the reader is in. Written once per chapter change by the
 * navigation rail's ScrollTriggers and read by the rail + chapter readouts,
 * so nothing else has to observe scroll.
 */
const SectionContext = createContext(null);

export const useSection = () => useContext(SectionContext);

export const SectionProvider = ({ children }) => {
  const [activeId, setActiveId] = useState(chapters[0].id);

  const setSection = useCallback((id) => {
    setActiveId((prev) => (prev === id ? prev : id));
  }, []);

  const value = useMemo(() => {
    const active = chapters.find((c) => c.id === activeId) || chapters[0];
    return { activeId, active, setSection };
  }, [activeId, setSection]);

  return <SectionContext.Provider value={value}>{children}</SectionContext.Provider>;
};
